/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Company } from '../../models/company';

export interface ApiV0CompanyGetCompaniesGet$Plain$Params {
}

export function apiV0CompanyGetCompaniesGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0CompanyGetCompaniesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Company>>> {
  const rb = new RequestBuilder(rootUrl, apiV0CompanyGetCompaniesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Company>>;
    })
  );
}

apiV0CompanyGetCompaniesGet$Plain.PATH = '/api/v0/company/getCompanies';
